import Config from '../Config';
import Utils from "../../common/Utils";

const parseRange = document.createRange();
const parse = Range.prototype.createContextualFragment.bind(parseRange);

const searchTab = ()=>{
  let itmes = ``,
    markup='';

  for (let key in Config.tabMenus) {
    let tab = Config.tabMenus[key],
      alias = tab.alias,
      title = tab.title;
    itmes += `
        <a href="#alias=${alias}" class="ui-tab-item" data-value='${alias}'>${title}</a>
        `;
  }

  markup = `
      <div class="ui-tab-wrap">
         ${itmes}
      </div>
      `;

  return parse(markup);
}
const filter = (_data)=>{
  let filter='',
    sort='',
    markup='';
  for (let key in _data) {
    let data = _data[key],
      item = '';
    for (let i = 0, len = data.length; i < len; i++) {

      if(key == 'serverId'){
        item += `<option value="${data[i].serverId}" data-server-type="${data[i].serverType}">${data[i].serverName}</option>`;
      }else if(key == 'classId'){
        item += `<option value="${data[i].id}" data-server-types="${data[i].serverTypes}">${data[i].name}</option>`;
      }else{
        item += `<option value="${data[i].value}">${data[i].title}</option>`;
      }
    }
    if(key.indexOf('sort') <= -1 && key.indexOf('zone') <= -1){
      filter += `<select class="ui-select is-borderless" id="select-${key}" data-filter="${key}">${item}</select>`;
    }else{
      sort += `<select class="ui-select is-borderless search-filter-select" id="select-${key}" data-filter="${key}">${item}</select>`;
    }
  };
  markup = `
      <div id="filterWrap" class="search-filter max-width-container">
        
        <div class="search-filter-inner">
        ${
            sort != '' ? `
                        <div class="btn-show-filter"></div> 
                        `
            : ``
        }   
         
          <div class="search-filter-count">검색결과 <em class="count">0</em>건</div>
          <div class="search-filter-selects">
          ${filter}${sort}
          
          </div>
        </div>
      </div>
    `;
  return parse(markup);
}

const section = (_alias, _data, _query)=>{
  let items = ``,
      markup='';
  if(_data){
    items =  getItems[_alias+'Items'](_data, _query);
  }

  markup = `
      <section class="section-result section-result-${_alias} ">${items}</section>
    `;

  return parse(markup);
}

const totalSection = (_data, _query) =>{
  let markup='';
  let categorys = Config.indexCategory;

  for (let alias in categorys) {
    let lists = [];
    if(alias == 'tag'){
      lists = _data[alias]['front'] || [];
    }else if(alias == 'guidebook'){
      lists = _data[alias]['searchHits'] || [];
    }else{
      lists = _data[alias]['documents']|| [];
    }
    if(lists.length){
      let items = getItems[alias+'Items'](lists, _query);
      let url = '';
      (categorys[alias].isDirect) ? url = categorys[alias].url : url = `#alias=${alias}&query=${Utils.getHashParams().query}`;
      markup += `
          <section class="section-result section-result-${alias} section-result-total">
            <h2 class="section-result-title">${categorys[alias].title}</h2>
            ${items}    
              ${
                categorys[alias].isDirectHide?'':
                `<a href="${url}" class="result-items-more">
                  ${
                    categorys[alias].isDirect  ?
                      `${categorys[alias].title} 바로가기` :
                      categorys[alias].title == '가이드북'  ?
                      `${categorys[alias].title} 더보기 (${_data[alias]['pageNavigation']['totalCount']}건)`:
                      `${categorys[alias].title} 더보기 (${_data[alias]['pagination']['totalCount']}건)`
                  }
                </a>`
              }

          </section>
      `;
    }
  }
  if(markup === '')return false;
  return parse(markup);
};

let getItems = {
  directItems:(_data)=>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      items += `
      <div class="result-direct">      
        <div class="result-direct-title">${data.title}</div>
          <a href="${data.url}" class="result-direct-link">${data.url}</a>
            
          </a>
      </div>`;
    }

    return items;
  },
  nshopItems:(_data)=>{
    let items = '';
    for (let key in _data) {
      let data = _data[key];
      let url = `${Config.nshopDomain}${data.url}`;
      let currencyType = (data.currencyGroupId == 13 ) ? ` icon-point` : ` icon-coin`;

      items += `
      <li class="result-items result-nshop">
        <a href="${url}">
          <div class="result-items-thumb result-thumb-nshop" style="background-image: url('${data.thumbnail}')"></div>   
          <div class="result-items-info">
            <div class="info-title">${data.goodsName}</div>
            <div class="info-meta">
              <span class="info-meta-icon ${currencyType}">${data.price}</span>
              <span class="info-meta-icon icon-point">${data.rewardPoint} (적립)</span>
            </div>  
          </div>       
        </a>   
      </li>
    `;
    }

    return `
      <ul>
        ${items}
      </ul>`;
  },
  promotionItems:(_data)=>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let urls = data.url.split('|');
      let url = '';
      switch (Config.device) {
        case 'mobile':
          url = urls[1];
          break;
        case 'app':
          url = urls[2];
          break;
        case 'ingame':
          url = urls[3];
          break;
        default :
          url = urls[0];
      }
      if(url == '')url = urls[0];
      let serverType = (data.category == 'live')?'라이브':'프론티어';
      // <span class="thumb-server ${data.category}">${serverType}</span>
      items += `
      <div class="result-items-event">
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">${data.title}</div>
            <div class="info-meta">
             <span class="info-meta-item">${Utils.getDate2(data.startDate)} ~ ${Utils.getDate2(data.endDate)}</span>                          
            </div>  
          </a>
               
        </div>
      </div>`;
    }

    return items;
  },
  contentlistItems:(_data)=>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url = data.link;
      let serverType = (data.optionalCategoryName == '라이브')?'live':'frontier';
// <span class="thumb-server ${serverType}">${data.optionalCategoryName}</span>
      items += `
      <div class="result-items">
        ${
        data.thumbnail ? `
            <a href="${url}" class="result-items-thumb" style="background-image: url('${data.thumbnail}')">
               
            </a>`
          : ``
      }        
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">${data.title}</div>
            <div class="info-contents">${data.summary}</div>
          </a>
          <div class="info-meta">
            <span class="info-meta-item">${Utils.getDate(data.updateDate)}</span>
          </div>       
        </div>
      </div>`;
    }

    return items;
  },
  bbsItems : (_data) =>{
    let items = '';
    const serverNameMap = {};
    for(let key in window._serverNameMap){
      serverNameMap[window._serverNameMap[key].serverId] = {
        serverName:window._serverNameMap[key].serverName
      };
    }
    for (let key in _data) {
      let data = _data[key];
      let type;
      let level = '';

      let url =  data.rootBoard.board.boardUrlPattern.replace('{articleId}', data.id)


      const recommendUpCount = parseInt(data.reactions.recommendUpCount, 10);
      const recommendDownCount = parseInt(data.reactions.recommendDownCount, 10);
      const maxCount = Math.max(recommendUpCount, recommendDownCount);

      if (maxCount > 0 && maxCount <= 9) {
        level = '_level1';
      } else if (9 < maxCount && maxCount <= 19) {
        level = '_level2';
      } else if (19 < maxCount) {
        level = '_level3';
      }

      if (recommendUpCount > recommendDownCount) {
        type = 'up';
      } else if (recommendUpCount < recommendDownCount) {
        type = 'down';
      } else if (recommendUpCount === recommendDownCount) {
        type = 'same';
        level = '';
      }
      items += `
      <div class="result-items-bbs">
        <div class="result-items-bbs-inner result-items-info">
          <div class="result-items-bbs-info ">
            <a class="result-items-bbs-article" href="${url}">
              <div class="info-title">${data.title}</div>
              <div class="info-contents">${data.searchSummary}</div>
            </a>
            ${
                data.thumbnailUrl != '' ? `
                    <a class="result-items-bbs-thumb" href="${url}" style="background-image: url('${data.thumbnailUrl}')">
                    </a>`
                  : ``
              }       
          </div>
          <div class="result-items-bbs-meta">
            ${
              data.writer.admin ? `
                  <span class="info-meta-item view-logo">admin </span>
                  `
                : `
                  ${
                  data.writer.gameUser.gameCharacterName != '' ? `
                  <span class="info-meta-item name">${data.writer.gameUser.gameCharacterName} </span>
                  `:`
                  <span class="info-meta-item name">${data.writer.loginUser.name} </span>
                  `
                }
                  
                `
            }   
            <span class="info-meta-item">${data.rootBoard.board.boardName} 
            ${
        data.rootBoard.board.boardAlias == data.categoryBoard.boardAlias ? ``:` > ${data.categoryBoard.boardName}`
      }
            </span>
           <span class="info-meta-item">${Utils.getDate(data.timestamps.updateDateTime)}</span>
          </div>
        </div>               
        <div class="result-items-bbs-reactions">
          <div class="wrap-count">
              <span class="count">               
                ${data.reactions.viewCount}
              </span>
              <span class="comment">
                ${data.reactions.commentCount}
              </span>  
          </div>        
          ${
        maxCount != 0 ? `
                  <span class="recommend"><span class="icon-recmd-${type}${level}"></span></span>
                  ` : ''
            }    
          
        </div>               
      </div>`;
    }
// <span class="info-meta-icon icon-reply">${data.replyCount}</span>
    return items;
  },

  guidebookItems : (_data) =>{
    let items = '';
    for (let key in _data) {
      let data = _data[key];
      const { thumbnail_url, guide_name, content } = data;
      const tags = data.tags && data.tags.split(',');

      const last_modified_date =  Utils.getFormatDate(data.update_time);
      const link = `/guidebook/view?title=${encodeURI(Utils.removeTags(guide_name))}`;
      const getTags = tags =>{
        let tagItem = '';
        tags.forEach(tag => {
          tagItem += `<li class="ncgbs-tags-item"><a href="/search/tag?query=${Utils.removeTags(tag)}" class="ncgbs-tags">${tag}</a></li>`;
        });
        return tagItem;
      };

      items += `
      <div class="ncgbs-result-items">
        <div class="ncgbs-result-contents-wrap ${thumbnail_url?'':'no-thumbnail'}">
          ${
          thumbnail_url ? `<div class="ncgbs-result-thumb">
                               <a href="${link}" class="thumb-wrap" style="background-image:url(${thumbnail_url})"></a>
                            </div>`
            : ``
          }        
          <div class="ncgbs-result-contents">
            <div class="ncgbs-result-title">
              <a href="${link}">${guide_name}</a>
             </div>
            <div class="ncgbs-result-summary">
              <a href="${link}">${content.replace(/<img .*?/gi, '')}</a>
            </div>
          </div>
        </div>
        ${tags ? `
          <ul class="ncgbs-result-tags">    
            ${getTags(tags)}
          </ul>
          <div class="ncgbs-result-info"><span class="ncgbs-update">업데이트</span><span class="ncgbs-date">${last_modified_date}</span></div>
        `: ''}
      </div>
        `;
    }

    return items;
  },
  characterItems : (_data) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      // let url =  `/world/character/${data.serverType.toUpperCase()}/${data.serverId}/${data.charName.replace(/<(\/strong|strong)([^>]*)>/gi,"")}`
      let charThumb = `character-thumb-${data.raceId}${data.gender}`;
      let imgUrl = `${Config.profileImgDomain}${data.profileImageUrl}`;
      let lv1 = `Lv. ${data.level}`;
      let lv2 = '';
      if(data.masteryLevel > 0)lv2 = ` &middot; 홍문 ${data.masteryLevel}성`;
      items += `
      <div class="result-items">
          <div  class="result-items-thumb result-thumb-circle character-thumb">
              <div class="thumb-img" style="background-image: url('${imgUrl}')"></div>
          </div>         
          <div class="result-items-info">
            <div class="info-title">${data.charName}</div>
            <div class="info-meta">
              <span class="info-meta-item name">${data.className}</span>
              <span class="info-meta-item">${data.serverName}</span>
              <span class="info-meta-item">${lv1}${lv2}</span>
            </div>
          </div>
      </div>`;
    }

    return items;
  },

  guildItems : (_data) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url =  `/world/guild/${data.serverType.toUpperCase()}/${data.serverId}/${data.guildName.replace(/<(\/strong|strong)([^>]*)>/gi,"")}`
      items += `
      <div class="result-items">           
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">${data.guildName}</div>
          </a>   
          <div class="info-server">${data.serverName}</div>  
          <div class="info-meta">
            <span class="info-meta-item fix-width">문파장</span>
            <span class="info-meta-item name">${data.leaderCharname}</span>
            <span class="info-meta-item fix-width">Lv ${data.level}</span>
            <span class="info-meta-item">창설일 ${Utils.getDate(data.makedate)}</span>
          </div>        
        </div>
      </div>`;
    }

    return items;
  },

  npuserItems : (_data) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url = `${Config.sandboxDomain}/${data.userId}`;
      let imgUrl =`${Config.profileImgDomain}${data.profileImageUrl}`;
      items += `
      <div class="result-items">          
        <a href="${url}" class="result-items-thumb result-thumb-circle npuser-thumb">
            <div class="thumb-img" style="background-image: url('${imgUrl}')"></div>
        </a>     
        <div class="result-items-info"> 
          <a href="${url}">
            <div class="info-title">${data.userName}</div>
          </a>
          <div class="info-meta">
            <span class="info-meta-item">NC친구 ${data.friendCount}</span>
            <span class="info-meta-item">구독자수 ${data.followerCount}</span>
          </div>    
          <div class="info-contents">${data.prflIntro}</div>  
        </div>
      </div>`;
    }
    return items;
  },

  videoItems : (_data) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url = `${Config.nctvDomain}/view?tv=bns&id=${data.videoId}`;
      let thmbnail = new Image();
      thmbnail.src = data.videoThumbnail;

      thmbnail.onload = () =>{
        $(`[data-id = "${data.videoId}"] .result-thumb-video`).css('background-image', `url(${thmbnail.src})`).addClass('is-loading');
      };

      thmbnail.onerror = () =>{
        $(`[data-id = "${data.videoId}"] .result-thumb-video`).css('background-image', `url(${data.channelThumbnail})`).addClass('is-loading');
      };

      items += `
      <div class="result-items result-video" data-id="${data.videoId}">  
        <a href="${url}" class="result-items-thumb result-thumb-video">
            <span class="icon-video"></span>
        </a>         
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">${data.title}</div>
            <div class="info-contents">${data.contents}</div>
          </a>   
          <div class="info-meta">
            <span class="info-meta-item">${data.channelName}</span>
          </div> 
          <div class="info-meta">
            <span class="info-meta-item">${Utils.getTime(data.playtime)}</span>
            <span class="info-meta-item">${Utils.getDate(data.date)}</span>
          </div>             
        </div>
      </div>`;
    }
    //<a href="javascript:;" class="info-btn" data-youtube-id="${data.yotubeId}">바로보기</a>
    return items;
  },

  faqItems : (_data) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url = `${Config.csDomain}/faq/search?faqNo=${data.faqNo}`;

      items += `
      <div class="result-items">    
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">${data.subject}</div>
            <div class="info-contents">${data.contents}</div>
          </a>    
          <div class="info-meta">
            <span class="info-meta-item">${data.categoryName}</span>
          </div>          
        </div>
      </div>`;
    }

    return items;
  },

  tagItems : (_data, _query) =>{
    let items = ''
    for (let key in _data) {
      let data = _data[key];
      let url = `/search/tag?query=${data.keyword}`;
      // const tags = (data.keyword || []).slice(0, NUM_LIMIT_USER_TAG).reduce((acc, cur) => {
      //   return (acc += `<a href="/search/tag?query=${window.encodeURIComponent(cur)}"><div class="info-title">#${cur}</div></a>`);
      // }, '');
      const title = (data.keyword || '').split(_query).join(`<strong>${_query}</strong>`) || '';
      items += `
      <div class="result-items result-items-tag">    
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">#${title}</div>
          </a>    
          <div class="info-meta">
            <span class="info-meta-item">게시글 ${data.count}건</span>
          </div>          
        </div>
      </div>`;
    }

    return items;
  }
}
const paging = (_data) =>{
  let itmes = ``,
  markup='',
  startNum = 1,
  max = 1,
  arr = [];
  const setUrl = _page =>{
    let hash = Utils.getHashParams();
    hash.page = _page;

    return Utils.addHashParams('', hash);
  }
  startNum = Math.floor(((_data.currentPage-1) / 5)) * 5 + 1;
  max = startNum+4;
  if(max >= _data.lastPage) max = _data.lastPage;
  for(let i = startNum; i <= max; i++){
    itmes += `
    <a href="${setUrl(i)}" class="ui-paging-num ${(_data.currentPage == i) ? 'is-active' : ''}">${i}</a>
    `;
  }

  markup = `
  <div class="ui-paging">
    <a ${(startNum <= 5)? 'disabled': `href="${setUrl(startNum-1)}"`} class="ui-paging-arrow is-prev"></a>
      ${itmes}
    <a ${(max >= _data.lastPage)? 'disabled': `href="${setUrl(max+1)}"`} class="ui-paging-arrow is-next"></a>
  </div>
  `;


  return parse(markup);
}
const pagingMore = (_data) =>{
  let markup='';
  markup = `
  <div class="wrap-community-more search-more-btn">
      <button class="nc-comment-more" aria-label="더보기"><span class="txt">더보기</span></button>
    </div>
  `;


  return parse(markup);
}
const none = () =>{
  let markup='';
  markup = `
      <section class="section-result-none">
        <div class="result-items-thumb"></div>
        <div class="result-items-info">
            <div class="info-title">검색 결과가 없습니다.</div>
            <div class="info-contents">검색어의 철자가 정확한지 확인해주세요. <br>검색어가 두 단어 이상일 경우, 띄어쓰기를 확인해주세요.</div>  
        </div>
      </section>
    `;

  return parse(markup);
}
const error = () =>{
  let markup='';
  markup = `
      <section class="section-result-none">
        <div class="result-items-thumb"></div>
        <div class="result-items-info">
            <div class="info-title">검색 결과를 가져올 수 없습니다. </div>
            <div class="info-contents">잠시 후 이용해주세요.</div>  
        </div>
      </section>
    `;

  return parse(markup);
}

const loading = () => {
  let markup='';
  markup = `
      <div class="loading-wrap is-show">
        <div class="loading"></div>
     </div>
    `;

  return parse(markup);
}

const tagItems = (_data, _query) =>{
  let items = ''
  for (let key in _data) {
  let data = _data[key];
  let url = `/search/tag?query=${data.keyword}`;
  // const tags = (data.keyword || []).slice(0, NUM_LIMIT_USER_TAG).reduce((acc, cur) => {
  //   return (acc += `<a href="/search/tag?query=${window.encodeURIComponent(cur)}"><div class="info-title">#${cur}</div></a>`);
  // }, '');
const title = (data.keyword || '').split(_query).join(`<strong>${_query}</strong>`) || '';
items += `
      <div class="result-items result-items-tag">    
        <div class="result-items-info">
          <a href="${url}">
            <div class="info-title">#${title}</div>
          </a>    
          <div class="info-meta">
            <span class="info-meta-item">게시글 ${data.count}건</span>
          </div>          
        </div>
      </div>`;
}


return parse(items);
}
export default {
  searchTab,
  filter,
  section,
  tagItems,
  totalSection,
  paging,
  pagingMore,
  none,
  error,
  loading
}
